import * as _ from "lodash";

export class DataMappingHelpers {

    public static formatName(name): string {
        if (name === "message" || name === "error" || name === "status") {
            name = "mapping_" + name;
        }
        if (name.endsWith("_at")) {
            name = name.substring(0, (name.length - 3));
        }
        return name.replace("answer.", "")
            .replace("content.", "")
            .replace("query_child_", "")
            .replace("write_child_", "")
            .replace("read_child_", "")
            .replace("list_child_", "")
            .replace("receive_child_", "")
            .replace("query_", "")
            .replace("write_", "")
            .replace("read_", "")
            .replace("list_", "")
            .replace("receive_", "")
            .replace("query.", "")
            .replace("write.", "")
            .replace("read.", "")
            .replace("list.", "")
            .replace("receive.", "")
            .replace("results_", "")
            .replace("collection_", "")
            .replace("_child_", " ")
            .replace(".*.", " ")
          .replace(".", " ")
          .replace(/__exact$/, "");
    }

    public static getFieldType(name, filter, realFilter) {
        if (realFilter === "catalog") {
            return "catalog";
        } else if (filter && (filter.includes(`${name}_collection_`) || filter.includes("child_*_child"))) {
            return "editgrid";
        } else if (filter && filter.includes(`${name}_child_`)) {
            return "block";
        } else {
            return null;
        }
    }

    public static getFieldTypeClass(type) {
        if (type) {
            switch (type) {
                case "catalog":
                    return "branch-bloc-icon far fa-stream";
                case "block":
                case "panel":
                    return "branch-bloc-icon far fa-window";
                case "editgrid":
                case "datagrid":
                    return "branch-bloc-icon far fa-th";
                case "tabs":
                    return "branch-bloc-icon far fa-folder-tree";
                case "container":
                    return "branch-bloc-icon far fa-box";
                case "select":
                    return "field-icon far fa-list bg-light-secondary";
            }
        }
    }

    public static getFieldClass(type, multiple = false) {
        if (type) {
            switch (type.toLowerCase()) {
                case "panel":
                    return "far fa-list-alt";
                case "editgrid":
                case "datagrid":
                    return "far fa-th bg-light-secondary";
                case "tabs":
                    return "far fa-folder-tree";
                case "catalog_folder":
                    return "far fa-stream";
                case "container":
                    return "far fa-box";
                case "table":
                    return "far fa-table";
                case "phonenumber":
                    return "far fa-phone bg-mid-grey";
                case "button":
                    return "far fa-bullseye-pointer bg-light-secondary";
                case "datetime":
                case "date-time":
                    return "far fa-calendar-day bg-light-info";
                case "date":
                case "day":
                    return "far fa-calendar-day bg-light-info";
                case "email":
                    return "far fa-at bg-light-danger";
                case "integer":
                case "number":
                case "decimal":
                case "numeric":
                    return "fas fa-calculator bg-light-success";
                case "file":
                case "fileupload":
                case "document":
                case "doc":
                case "requirement":
                case "result":
                    return multiple ? "fa-solid fa-files bg-light-warning" : "fas fa-file bg-light-warning";
                case "boolean":
                    return "fas fa-adjust";
                case "money":
                    return "far fa-money-bill-alt bg-light-sun";
                case "select":
                    return "far fa-list bg-light-secondary";
                case "hidden":
                    return "far fa-eye-slash";
                case "tag":
                case "string":
                case "textfield":
                case "textarea":
                case "classification":
                    return "far fa-text bg-light-danger";
                case "radio":
                    return "far fa-dot-circle bg-light-danger";
                case "selectboxes":
                case "checkbox":
                    return "far fa-check-square bg-light-danger";
                case "mycontent":
                case "content":
                case "htmlelement":
                    return "fab fa-html5 bg-light-danger";
                case "key":
                    return "fas fa-key bg-light-danger";
                case "url":
                case "link":
                    return "far fa-link bg-light-danger";
                case "catalog":
                case "select_folder":
                    return "far fa-bars bg-light-secondary";
                case null:
                default:
                    return "far fa-ghost";
            }
        } else {
            return "far fa-ghost";
        }
    }

    public static getSanitizeID(string = "", prefix = ""): string {
        if (!string) {
            return;
        }
        string = string.replace(/ /g, "-");
        string = string.replace(/\//g, "-");
        string = string.replace(/,/g, "-");
        return prefix + string;
    }

    public static getSanitizeString(string, prefix = ""): string {
        return prefix + string.replace(/ /g, "-");
    }

    public static existRelationship(lines, field, input): boolean {
        if (field.fieldKey) {
            return lines.some((line) => {
                return (line.field && line.field.fieldKey) ? line.field.fieldKey === field.fieldKey : false;
            });
        }
        return false;
    }

    public static normalizeFieldName(label: string): string {
        if (label) {
            label = label.replace("_child_", " - ");
            label = label.replace("_collection_", " - ");
            label = label.replace(".", " - ");
        }
        return label;
    }

    public static getFieldGroupName(input_name): any {
        const parts = (input_name.indexOf(".") !== -1) ? input_name.split(".") : input_name.split("_");
        return parts.length > 0 ? parts[0] : parts;
    }

    public static haveRelationship(lines, input): boolean {
        return lines.some((line) => {
            return _.isEqual(
                _.omit(line.input, ["level", "type", "remoteType", "filter", "disabled", "fieldName", "dataSrc"]),
                _.omit(input, ["level", "type", "remoteType", "filter", "disabled", "fieldName", "dataSrc"]),
            );
        });
    }

    public static getLine(lines, input): any {
        return _.find(lines, (line) => {
            return _.isEqual(
                _.omit(line.input, ["level", "type", "remoteType", "filter", "disabled", "fieldName", "dataSrc"]),
                _.omit(input, ["level", "type", "remoteType", "filter", "disabled", "fieldName", "dataSrc"]),
            );
        });
    }

    public static getLines(lines, input): any {
        return _.filter(lines, (line) => {
            return _.isEqual(
                _.omit(line.input, ["level", "type", "remoteType", "filter", "disabled", "fieldName", "dataSrc"]),
                _.omit(input, ["level", "type", "remoteType", "filter", "disabled", "fieldName", "dataSrc"]),
            );
        });
    }

    // get group prefix
    public static getSanitizeGroupName(input_name = ""): string {
        let parts = [];
        let name = input_name;
        if (input_name.indexOf("content_child_") !== -1) {
            parts = input_name.split("content_child_");
            name = parts.length > 1 ? DataMappingHelpers.getFieldGroupName(parts[1]) : parts;
        }
        if (input_name.indexOf("content_collection_") !== -1) {
            parts = input_name.split("content_collection_");
            name = parts.length > 1 ? DataMappingHelpers.getFieldGroupName(parts[1]) : parts;
        }
        if (input_name.indexOf("collection_content") !== -1) {
            parts = input_name.split("collection_content");
            name = parts.length > 1 ? DataMappingHelpers.getFieldGroupName(parts[1]) : parts;
        }
        if (input_name.indexOf("collection_child_") !== -1) {
            parts = input_name.split("collection_child_");
            name = parts.length > 1 ? DataMappingHelpers.getFieldGroupName(parts[1]) : parts;
        }
        return DataMappingHelpers.getSanitizeString(name);
    }
}
